import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import React from "react";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Message, Select } from "@components";

export class GoogleMapsDrawer extends React.Component {
  state = {
    savingOptions: false,
    value: {
      map: "",
      api: "",
      placesApiVersion: "LEGACY",
    },
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async getEnvironmentId() {
    const { holding } = this.props;

    let selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
    if (holding) {
      selectedEnvironment = await EnvironmentStorage.getEnvironmentHoldingId();
    }

    return selectedEnvironment;
  }

  async getConfiguration() {
    const selectedEnvironment = await this.getEnvironmentId();

    const credentials = await EnvironmentsAPI.getConfigurationsByAlias(
      selectedEnvironment,
      "external_credentials"
    );

    const PLACES_API_VERSION = credentials?.google?.PLACES_API_VERSION || 'LEGACY';

    const GOOGLE_MAPS_API_KEY =
      credentials?.google?.GOOGLE_MAPS_API_KEY || null;

    const GOOGLE_MAPS_MAP_KEY =
      credentials?.google?.GOOGLE_MAPS_MAP_KEY || null;

    if (!GOOGLE_MAPS_MAP_KEY) {
      return {
        map: GOOGLE_MAPS_API_KEY,
        api: GOOGLE_MAPS_API_KEY,
        placesApiVersion: PLACES_API_VERSION,
      };
    }

    return {
      map: GOOGLE_MAPS_MAP_KEY,
      api: GOOGLE_MAPS_API_KEY,
      placesApiVersion: PLACES_API_VERSION,
    };
  }

  async componentDidMount() {
    const value = await this.getConfiguration();
    this.setState({ value });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { api, map, placesApiVersion } = this.state.value;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment = await this.getEnvironmentId();

      const credentials = await EnvironmentsAPI.getConfigurationsByAlias(
        selectedEnvironment,
        "external_credentials"
      );

      if (!credentials.google) {
        credentials.google = {};
      }

      credentials.google.GOOGLE_MAPS_MAP_KEY = map;
      credentials.google.GOOGLE_MAPS_API_KEY = api;
      credentials.google.PLACES_API_VERSION = placesApiVersion;

      const response = await EnvironmentsAPI.putConfigurationsByAlias(
        selectedEnvironment,
        "external_credentials",
        credentials
      );
      await this.setAsyncState({ savingOptions: false });

      if (response.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível salvar a chave: ${response.getErrors()[0]}`,
        });
      }
    } catch (e) {
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose, holding } = this.props;
    const { value, savingOptions } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={holding ? "Google Maps (Holding)" : "Google Maps (Marca)"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Input
          design="two"
          className="mb-20"
          label="Chave de API (mapa)"
          value={value.map}
          onChange={(e) =>
            this.setState({
              value: {
                ...value,
                map: e.target.value,
              },
            })
          }
        />

        <Input
          design="two"
          className="mb-20"
          label="Chave de API (outros)"
          value={value.api}
          onChange={(e) =>
            this.setState({
              value: {
                ...value,
                api: e.target.value,
              },
            })
          }
        />

        <Select
            design="two"
            label="Versão da Places API"
            onChange={(e) => {
              this.setState({
                value: {
                  ...value,
                  placesApiVersion: e.target.value,
                },
              })
            }}
            className="flex-1 mb-20"
            value={value.placesApiVersion}
            options={[
                { label: "Antiga", value: "LEGACY", selected: value.placesApiVersion == "LEGACY" },
                { label: "Nova", value: "NEW", selected: value.placesApiVersion == "NEW" },
            ]}
        />

        <Message className="mt-20">
          <p>
            No campo <b>Chave de API (mapa)</b>, deve informar uma chave com
            permissão para a Maps JavaScript API, que será utilizada para o
            carregamento do mapa no Delivery.
          </p>
          <br />
          <p>
            Já no campo <b>Chave de API (outros)</b>, é necessário informar uma
            chave com permissão para as demais APIs (ex.: Geolocation API,
            Places API), que será usada internamente para buscas de endereços.
          </p>
        </Message>
      </Drawer>
    );
  }
}
